import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const RENTBURDENDIFFINVANY_LAYER_ID = 'rentBurdenDiffInvAnyLayer';

const layerConfig = {
  title: 'Rent Burden Diff layer',
};

function RentBurdenDiffInvAnyLayer() {
  const dispatch = useDispatch();
  const { rentBurdenDiffInvAnyLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, rentBurdenDiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (rentBurdenDiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: RENTBURDENDIFFINVANY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: rentBurdenDiffInvAnyLayer.visible,
      opacity: rentBurdenDiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'rent_burden_diff',
        domain: [-76, -10, -1, 0, 10, 30, 48],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: RENTBURDENDIFFINVANY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['rent_burden_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default RentBurdenDiffInvAnyLayer;
